import Card, { CardProps } from 'app/src/kit/Card'
import breakpoints from 'app/utils/window/breakpoints'
import { styled } from 'styled-components'

const StyledCard = styled(Card)`
  min-width: 400px;
  max-width: 480px;
  width: 100%;
  align-self: center;
  padding: 0;
  max-height: 100%;
  @media only screen and (max-width: ${breakpoints.TABLET - 1}px) {
    min-width: inherit;
    /** fix back to login button invisible */
    padding-bottom: 40px;
  }
`

const AuthCard: FC<CardProps> = ({ children, ...props }) => {
  return (
    <StyledCard {...props}>
      <Box $overflowY='auto' $p='lg' $m='sm'>
        {children}
      </Box>
    </StyledCard>
  )
}

export default AuthCard
